import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  registerPushNotifications,
  subscribeForegroundNotifications,
  unregisterPushNotificationToken,
} from '../services/pushNotificationService';

function NotificationDeliveryRegistration() {
  const { currentUser } = useAuth();
  const registrationRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    async function setup() {
      const unregisterForeground = await subscribeForegroundNotifications();
      if (cancelled) {
        unregisterForeground();
        return;
      }
      registrationRef.current = {
        ...registrationRef.current,
        unregisterForeground,
      };
    }

    setup();

    return () => {
      cancelled = true;
      registrationRef.current?.unregisterForeground?.();
    };
  }, []);

  useEffect(() => {
    let active = true;

    async function register() {
      if (!currentUser) return;
      const result = await registerPushNotifications(currentUser.uid).catch((error) => {
        console.warn('Push notification registration failed:', error);
        return null;
      });
      if (!active || !result) return;
      registrationRef.current = {
        ...registrationRef.current,
        userId: currentUser.uid,
        tokenDocId: result.tokenDocId,
      };
    }

    register();

    return () => {
      active = false;
      const previous = registrationRef.current;
      if (previous?.userId && previous?.tokenDocId) {
        unregisterPushNotificationToken(previous.userId, previous.tokenDocId);
        registrationRef.current = {
          ...previous,
          userId: null,
          tokenDocId: null,
        };
      }
    };
  }, [currentUser]);

  return null;
}

export default NotificationDeliveryRegistration;
